/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Import_TitleInputs */



/**
* | output |
* | --- |
* | "Iconik Import" |
*
* @param {Iconik_Import_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_import_title = /** @type {((inputs?: Iconik_Import_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Import_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Import Iconik")
	if (locale === "de") return /** @type {LocalizedString} */ ("Iconik Import")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione Iconik")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Iconik Import")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importación de Iconik")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Iconik 进口")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Iconikインポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आइकॉनिक आयात")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importação Icônica")
	return /** @type {LocalizedString} */ ("Iconik Import")
});